<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="340px"
    transition="dialog-transition"
  >
    <v-card>
      <v-card-title class="grey lighten-3">Move Days</v-card-title>
      <v-card-text class="pa-3">
        <v-layout align-baseline>
          <v-flex xs8 pr-3>
            <v-text-field
              label="Number of Days"
              type="number"
              v-model="days"
              min="1"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
          <v-flex xs4>
            <v-radio-group v-model="direction">
              <v-radio label="Forward" value="forward"></v-radio>
              <v-radio label="Backwards" value="backwards"></v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="grey lighten-4">
        <v-spacer></v-spacer>
        <v-btn color="warning" text @click="onCancel">Cancel</v-btn>
        <v-btn color="primary" @click="onMoveDays">Move Days</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ItineraryBuilderMoveDays",
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      days: 1,
      direction: "forward",
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  watch: {
    show(newVal) {
      if (!newVal) {
        this.days = 1;
        this.direction = "forward";
      }
    },
  },

  methods: {
    onCancel() {
      this.$emit("onCancel");
    },
    onMoveDays() {
      let days = this.direction == "backwards" ? this.days * -1 : this.days;
      this.$emit("onMoveDays", { direction: this.direction, days: days });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/tools/ItineraryBuilderMoveDays.vue